import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './locales/en';
import { tc } from './locales/tc';

const resources = {
  en: {
    translation: en
  },
  'zh-TW': {
    translation: tc
  }
};

/* Old inline resources - kept for reference, now in separate files
const resources = {
  en: {
    translation: {
      brand: { title: 'CCBC Admin', subtitle: 'Control Panel' },
      navigation: {
        dashboard: 'Dashboard',
        admins: 'Admin Management',
        'tithe-receipts': 'Tithe Receipt Management',
        members: 'Member Management',
        organization: 'Organization Structure',
        events: 'Events',
        attendance: 'Attendance Records',
        check_in: 'Check In (QR Scan)',
        continuous_checkin: 'Continuous Check-in',
        joomla: 'Joomla Articles',
        posts: 'Posts',
        'access-control': 'Access Control'
      },
        organization: {
          title: 'Organization Structure',
          subtitle: 'District → Zone → Group',
          legend: {
            district: 'District',
            zone: 'Zone',
            group: 'Group'
          },
          loading: 'Loading organization data...',
          error: 'Failed to load organization data.',
          reload: 'Reload',
          addFirst: 'Add First Area',
          empty: 'No organization structure yet',
          filters: {
            districtLabel: 'District:',
            zoneLabel: 'Zone:',
            groupLabel: 'Group:',
            districtPlaceholder: 'Search district...',
            zonePlaceholder: 'Search zone...',
            groupPlaceholder: 'Search group...',
            districtEmpty: 'No districts found',
            zoneEmpty: 'No zones found',
            groupEmpty: 'No groups found',
            clearAll: 'Clear filters'
          },
          actions: {
            addDistrict: 'Add District',
            addZone: 'Add Zone',
            addGroup: 'Add Group',
            manageMembers: 'Manage Members',
            edit: 'Edit',
            delete: 'Delete',
            groupCount: '{{count}} groups',
            zoneCount: '{{count}} zones'
          },
          badges: {
            district: 'District',
            zone: 'Zone',
            group: 'Group'
          },
          detail: {
            districtManager: 'District Pastor:',
            zoneManager: 'Zone Leader:',
            groupManager: 'Group Leader:',
            noneAssigned: 'Unassigned'
          },
          stats: {
            core: 'Core Members',
            full: 'Full Members',
            associate: 'Associate Members',
            total: 'Total'
          },
          confirmDelete: 'Are you sure you want to delete this {{type}}?',
          confirmRemoveMember: 'Remove this member?',
          deleteError: 'Failed to delete. Please try again later.',
          saveError: 'Failed to save. Please try again later.',
          removeError: 'Failed to remove member.',
          types: {
            district: 'District',
            zone: 'Zone',
            group: 'Group',
            districtManager: 'District Pastor',
            zoneManager: 'Zone Leader',
            groupManager: 'Group Leader'
          },
          modal: {
            createTitle: 'Create ',
            editTitle: 'Edit ',
            parentLabel: 'Parent {{parent}}',
            nameLabel: '{{type}} Name *',
            namePlaceholder: 'e.g. {{type}} name',
            managerLabel: '{{manager}} *',
            loadingMembers: 'Loading members...',
            searchManager: 'Search {{manager}} name or ID...',
            moreMembers: '{{count}} more members...',
            noMembers: 'No matching members',
            description: 'Description',
            descriptionPlaceholder: 'Optional',
            cancel: 'Cancel',
            save: 'Save'
          },
          membersModal: {
            title: '{{group}} Members',
            summaryCore: 'Core: {{count}}',
            summaryFull: 'Full: {{count}}',
            summaryAssociate: 'Associate: {{count}}',
            addLabel: 'Add Member',
            searchPlaceholder: 'Search member name or ID...',
            loadingMembers: 'Loading members...',
            moreMembers: '{{count}} more members...',
            noMembers: 'No matching members',
            roleCore: 'Core Member',
            roleFull: 'Full Member',
            roleAssociate: 'Associate Member',
            addButton: 'Add',
            loadingAssignments: 'Loading...',
            empty: 'No members yet',
            worshipId: 'Worship ID: {{id}}',
            worshipMissing: 'Worship ID not provided',
            remove: 'Remove',
            saveAll: 'Save Changes',
            close: 'Close',
            addSuccess: 'Member added successfully',
            addError: 'Failed to add member',
            roleSuccess: 'Roles updated successfully',
            roleError: 'Failed to update roles',
            removeError: 'Failed to remove member'
          }
        },
      navigationDesc: {
        dashboard: 'Overview of your CCBC platform statistics and activities',
        admins: 'Manage CCBC platform administrators and their permissions',
        posts: 'Create, edit, and manage platform posts and articles',
        events: 'Manage events and their sections/classes with datetime scheduling',
        attendance: 'View and manage attendance records from check-ins',
        check_in: 'Check in attendance by scanning QR codes for event sections',
        continuous_checkin: 'Continuous QR scanner - scan multiple QR codes one by one without stopping',
        joomla: 'View and monitor articles from your Joomla CMS',
        'access-control': 'Configure user permissions and access levels',
        members: 'Manage member profiles, details, and roles',
        organization: 'Visualize and edit your organization structure',
        'tithe-receipts': 'Manage tithe receipt issuance and history'
      },
      status: { online: 'Online' },
      actions: { logoutConfirm: 'Are you sure you want to logout?', logout: 'Logout' },
      language: { label: 'Language', en: 'English', 'zh-TW': '繁體中文' },
      loading: { loading: 'Loading...' },
      login: {
        title: 'CCBC Admin Panel',
        subtitle: 'Sign in to your admin account',
        username: 'Username',
        password: 'Password',
        usernamePlaceholder: 'Enter your username',
        passwordPlaceholder: 'Enter your password',
        submit: 'Sign in',
        submitting: 'Signing in...',
        loggingIn: 'Logging in...',
        footer: '© 2025 CCBC Project. All rights reserved.'
      },
      common: {
        na: 'N/A',
        back: 'Back',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        successTitle: 'Success',
        errorTitle: 'Error'
      },
      member: {
        detail: {
          title: 'Member Details',
          backShort: 'Back',
          backToList: 'Back to Members List',
          loadingData: 'Loading member data...',
          failedToLoad: 'Failed to load member data. Please try again.',
          notFound: 'Member not found',
          confirmDelete: 'Are you sure you want to delete {{name}}? This action cannot be undone.',
          successDeleteTitle: 'Success',
          successDeleteMsg: 'Member deleted successfully!',
          errorDeleteTitle: 'Error',
          errorDeleteMsg: 'Failed to delete member. Please try again.',
          personalInfo: 'Personal Information',
          gender: 'Gender:',
          dob: 'Date of Birth:',
          idNumber: 'ID Number:',
          maritalStatus: 'Marital Status:',
          occupation: 'Occupation:',
          contactInfo: 'Contact Information',
          mobile: 'Mobile:',
          email: 'Email:',
          address: 'Address:',
          membershipInfo: 'Membership Information',
          membershipType: 'Membership Type:',
          joinDate: 'Join Date:',
          baptismDate: 'Baptism Date:',
          baptismPlace: 'Baptism Place:',
          emergencyContact: 'Emergency Contact',
          contactName: 'Contact Name:',
          contactPhone: 'Contact Phone:',
          relationship: 'Relationship:',
          additionalNotes: 'Additional Notes',
          created: 'Created:',
          lastUpdated: 'Last Updated:',
          worshipNo: 'Worship No.'
        },
        list: {
          title: 'Member Management',
          add: 'Add New Member',
          searchPlaceholder: 'Search by name, worship number, mobile, or email...',
          statusAll: 'All Status',
          statusActive: 'Active',
          statusInactive: 'Inactive',
          statusSuspended: 'Suspended',
          loading: 'Loading members...',
          error: 'Failed to load members. Please try again.',
          retry: 'Retry',
          table: {
            worship: 'Worship No.',
            nameChi: 'Name (中文)',
            nameEng: 'Name (English)',
            mobile: 'Mobile',
            email: 'Email',
            status: 'Status',
            joinDate: 'Join Date',
            actions: 'Actions'
          },
          empty: 'No members found.',
          view: 'View',
          edit: 'Edit',
          delete: 'Delete',
          confirmDelete: 'Are you sure you want to delete {{name}}?',
          deleteSuccess: 'Member deleted successfully!',
          deleteError: 'Failed to delete member. Please try again.',
          pagination: {
            showing: 'Showing {{from}} to {{to}} of {{total}} members',
            previous: 'Previous',
            next: 'Next',
            pageOf: 'Page {{page}} of {{total}}'
          }
        },
        form: {
          createTitle: 'Add New Member',
          editTitle: 'Edit Member',
          cancelConfirm: 'Are you sure you want to cancel? Any unsaved changes will be lost.',
          successCreate: 'Member created successfully!',
          successUpdate: 'Member updated successfully!',
          save: 'Save',
          saving: 'Saving...',
          cancel: 'Cancel',
          showAdvanced: 'Show More Details (Address, Education, Cell Groups, Health, etc.)',
          hideAdvanced: 'Hide More Details (Address, Education, Cell Groups, Health, etc.)',
          showAdvancedShort: 'Show More Details',
          hideAdvancedShort: 'Hide Details',
          updateAction: 'Update Member',
          createAction: 'Create Member',
          sections: {
            basic: 'Basic Information',
            contact: 'Contact Information',
            address: 'Address',
            postalAddress: 'Postal Address',
            membership: 'Membership',
            education: 'Education',
            family: 'Family',
            occupation: 'Occupation',
            baptism: 'Baptism',
            religion: 'Religious Background',
            service: 'Service',
            cellGroup: 'Cell Group',
            health: 'Health',
            emergency: 'Emergency Contact',
            communication: 'Communication',
            remarks: 'Remarks'
          },
          labels: {
            worshipId: 'Worship ID',
            status: 'Status *',
            chiName: 'Chinese Name *',
            engName: 'English Name',
            nickname: 'Nickname',
            gender: 'Gender',
            dob: 'Date of Birth',
            hkid: 'HKID / Passport',
            nativePlace: 'Native Place',
            mobile: 'Mobile',
            email: 'Email',
            telDay: 'Tel (Day)',
            telNight: 'Tel (Night)',
            companyTel: 'Company Tel',
            fax: 'Fax',
            addr: 'Address',
            addrDistrict: 'District',
            region: 'Region',
            street: 'Street',
            estate: 'Estate',
            building: 'Building',
            unitNumber: 'Unit Number',
            postalAddr: 'Postal Address',
            statusActive: 'Active',
            statusInactive: 'Inactive',
            statusSuspended: 'Suspended',
            dateOfJoin: 'Join Date',
            dateOfJoinAdd: 'Additional Join Date',
            dateOfTransferAdd: 'Transfer Join Date',
            eduGrade: 'Education Grade',
            eduName: 'Education',
            marriedStatus: 'Marital Status',
            dateOfMarried: 'Date of Marriage',
            childQty: 'Number of Children',
            job: 'Job',
            income: 'Income',
            workRegion: 'Work Region',
            proQual: 'Professional Qualifications',
            dateOfBaptism: 'Baptism Date',
            baptismChurch: 'Baptism Church',
            baptismNo: 'Baptism No.',
            baptistPriest: 'Baptist Priest',
            baptismAppointment: 'Baptism Appointment Date',
            religion: 'Religion',
            everChurch: 'Previous Church',
            believeDate: 'Date of Belief',
            servePosts: 'Service Roles',
            serveExp: 'Service Experience',
            cellGroup1: 'Cell Group',
            cellGroup2: 'Cell Group 2',
            cellGroup3: 'Cell Group 3',
            cellGroup4: 'Cell Group 4',
            health: 'Health',
            healthItems: 'Health Details',
            emergencyPerson: 'Emergency Contact',
            emergencyTel: 'Emergency Contact Tel',
            emergencyRelation: 'Relationship',
            receiveInfo: 'Receive Info',
            remark: 'Remark',
            remark2: 'Remark 2'
          },
          placeholders: {
            worshipId: 'e.g., 170074 or T170074',
            statusFormat: 'Format: Regular member (170074) or Temporary (T170074)',
            emergencyRelation: 'e.g., Spouse, Parent, Sibling',
            remark: 'Any additional notes or comments...',
            eduGrade: 'e.g., Secondary School, University, Master'
          },
          options: {
            genderSelect: 'Select Gender',
            genderMale: 'Male',
            genderFemale: 'Female',
            genderOther: 'Other',
            maritalSelect: 'Select Status',
            maritalSingle: 'Single',
            maritalMarried: 'Married',
            maritalDivorced: 'Divorced',
            maritalWidowed: 'Widowed'
          },
          errors: {
            load: 'Failed to load member data. Please try again.',
            save: 'Failed to save member. Please try again.'
          }
        }
      },
      access: { deniedTitle: 'Access Denied', deniedDescription: "You don't have permission to access this section." }
      ,
      admin: {
        secureNotice: 'Secure Admin Area - All API calls protected with Bearer authentication',
        headerTitle: 'Admin Management',
        headerSubtitle: 'Manage administrators and their permissions',
        list: {
          addNewAdmin: 'Add New Admin',
          errorLoading: 'Error loading admins',
          searchPlaceholder: 'Search admins...',
          perPage: '{{count}} per page',
          table: {
            admin: 'Admin',
            email: 'Email',
            status: 'Status',
            permissions: 'Permissions',
            created: 'Created',
            actions: 'Actions',
            active: 'Active',
            inactive: 'Inactive',
            permissionsCount: '{{count}} permission(s)',
            modulesCount: '{{count}} module(s)'
          },
          empty: 'No admins found.',
          emptySearch: 'No admins found matching your search.',
          manage: 'Manage',
          delete: 'Delete',
          confirmDelete: 'Are you sure you want to delete this admin?',
          notifications: {
            deleteSuccess: 'Admin deleted successfully',
            deleteError: 'Failed to delete admin'
          },
          pagination: {
            showing: 'Showing {{from}} to {{to}} of {{total}} admins',
            previous: 'Previous',
            next: 'Next'
          }
        },
        form: {
          title: 'Create New Admin',
          username: 'Username',
          email: 'Email',
          firstName: 'First Name',
          lastName: 'Last Name',
          password: 'Password',
          passwordPlaceholder: 'Enter secure password (min 6 characters)',
          usernamePlaceholder: 'Enter username',
          emailPlaceholder: 'Enter email address',
          firstNamePlaceholder: 'First name',
          lastNamePlaceholder: 'Last name',
          active: 'Active (user can log in)',
          cancel: 'Cancel',
          create: 'Create Admin',
          creating: 'Creating...',
          notifications: {
            createSuccess: 'Admin created successfully',
            createError: 'Failed to create admin'
          }
        },
        modal: {
          title: 'Manage Admin - {{username}}',
          tabs: {
            edit: 'Edit Admin',
            permissions: 'Access Control'
          },
          info: {
            title: 'Access Control Information',
            description: 'Configure which modules this admin can access and what actions they can perform.'
          },
          fields: {
            username: 'Username',
            email: 'Email',
            firstName: 'First Name',
            lastName: 'Last Name',
            active: 'Active'
          },
          permissions: {
            create: 'Create',
            read: 'Read',
            update: 'Update',
            delete: 'Delete',
            manage: 'Manage'
          },
          modules: {
            dashboard: 'Dashboard',
            admins: 'Admin Management',
            members: 'Member Management',
            events: 'Event Management',
            attendance_records: 'Attendance Records',
            attendance_checkin: 'Attendance Check-in',
            tithe_receipts: 'Tithe Receipt Management',
            posts: 'Post Management',
            joomla: 'Joomla Integration'
          },
          noChangesTitle: 'No Changes',
          noChangesMsg: 'No changes were made to update.',
          save: 'Save Changes',
          saving: 'Saving...',
          cancel: 'Cancel',
          notifications: {
            updateSuccess: 'Admin updated successfully',
            updateError: 'Failed to update admin',
            permsSuccess: 'Permissions updated successfully',
            permsError: 'Failed to update permissions'
          }
        }
      },
      tithe: {
        secureNotice: 'Secure Tithe Management - Bearer token authentication enabled',
        title: 'Tithe Receipt Management',
        refresh: 'Refresh',
        searchPlaceholder: 'Search by name, phone, worship code, bank...',
        filters: {
          statusAll: 'All Status',
          statusPending: 'Pending',
          statusApproved: 'Approved',
          statusRejected: 'Rejected',
          yearAll: 'All Years',
          monthAll: 'All Months',
          month01: 'January',
          month02: 'February',
          month03: 'March',
          month04: 'April',
          month05: 'May',
          month06: 'June',
          month07: 'July',
          month08: 'August',
          month09: 'September',
          month10: 'October',
          month11: 'November',
          month12: 'December',
          perPage: '{{count}} per page'
        },
        stats: {
          monthlyTitle: 'This Month ({{month}})',
          allTime: 'All Time',
          receipts: 'Receipts',
          pending: 'Pending',
          approved: 'Approved',
          totalAmount: 'Total Amount'
        },
        table: {
          receiptInfo: 'Receipt Info',
          contact: 'Contact',
          payment: 'Payment Details',
          amount: 'Amount',
          status: 'Status',
          actions: 'Actions',
          worship: 'Worship:',
          createdAt: 'Created:',
          emailMissing: 'No email',
          statusLabel: {
            pending: 'Pending',
            approved: 'Approved',
            rejected: 'Rejected'
          },
          view: 'View',
          approve: 'Approve',
          reject: 'Reject',
          download: 'Download',
          breakdown: {
            tithe: 'Tithe',
            building: 'Building',
            thanksgiving: 'Thanksgiving',
            loveFund: 'Love Fund'
          }
        },
        pagination: {
          showing: 'Showing {{from}} to {{to}} of {{total}} results',
          previous: 'Previous',
          next: 'Next',
          pageOf: 'Page {{page}} of {{total}}'
        },
        empty: {
          none: 'No tithe receipts found',
          adjust: 'Try adjusting your search criteria'
        },
        notifications: {
          fetchError: 'Failed to fetch tithe receipts',
          statsError: 'Failed to fetch statistics',
          statusUpdated: 'Receipt {{status}} successfully',
          statusError: 'Failed to update status',
          receiptError: 'Failed to fetch receipt details',
          downloadStarted: 'Receipt file download started',
          downloadError: 'Failed to download receipt file'
        },
        modal: {
          title: 'Tithe Receipt #{{id}}',
          status: 'Status',
          created: 'Created:',
          approve: 'Approve',
          reject: 'Reject',
          close: 'Close',
          approveTitle: 'Approve Receipt',
          approveConfirm: 'Are you sure you want to approve this tithe receipt?',
          approveRemarks: 'Approval Remarks (Optional):',
          approveSubmit: 'Approve',
          rejectTitle: 'Reject Receipt',
          rejectConfirm: 'Please provide a reason for rejecting this tithe receipt:',
          rejectReason: 'Rejection Reason:',
          rejectSubmit: 'Reject',
          cancel: 'Cancel',
          personalInfo: 'Personal Information',
          addressInfo: 'Address Information',
          paymentInfo: 'Payment Information',
          donationBreakdown: 'Donation Breakdown',
          additionalInfo: 'Additional Information',
          fields: {
            chineseName: 'Chinese Name:',
            englishName: 'English Name:',
            contactPhone: 'Contact Phone:',
            email: 'Email:',
            worshipCode: 'Worship Code:',
            address: 'Address:',
            district: 'District:',
            area: 'Area/Country:',
            receivingBank: 'Receiving Bank:',
            transactionType: 'Transaction Type:',
            depositDate: 'Deposit Date:',
            referenceNumber: 'Reference Number:',
            tithe: 'Tithe Amount (當納十分一):',
            thanksgiving: 'Thanksgiving Offering (感恩奉獻):',
            churchOperating: 'Church Operating (教會經常費):',
            buildingFund: 'Building Fund (建堂基金):',
            gospelMinistry: 'Gospel Ministry (福音事工):',
            loveNeighbor: 'Love Neighbor Fund (愛鄰舍基金):',
            specialOffering: 'Special Offering (特別奉獻):',
            specialOfferingDesc: 'Special Offering Description:',
            totalAmount: 'Total Amount:',
            receiptRequired: 'Receipt Required:',
            languagePreference: 'Language Preference:',
            uploadedReceipt: 'Uploaded Receipt:',
            remarks: 'Remarks:',
            processedBy: 'Processed By:',
            processedAt: 'Processed At:',
            yes: 'Yes',
            no: 'No'
          }
        }
      },
      events: {
        secureNotice: 'Secure Events Area - Bearer token authentication enabled',
        title: 'Events Management',
        tabs: {
          worship: 'Regular Worship',
          course: 'Course',
          cellGroup: 'Cell Group',
          meeting: 'Meeting',
          event: 'Event'
        },
        table: {
          id: 'ID',
          eventName: 'Event Name',
          venue: 'Venue',
          lecturer: 'Lecturer',
          sections: 'Sections',
          nextSection: 'Next Section',
          created: 'Created',
          actions: 'Actions',
          noEvents: 'No events found. Create your first event!',
          noMatch: 'No events found matching your search.'
        },
        actions: {
          manage: 'Manage',
          duplicate: 'Duplicate',
          delete: 'Delete',
          create: 'Create {{type}}'
        },
        filters: {
          searchPlaceholder: 'Search {{type}}...',
          searchWorships: 'Search worship services...',
          searchCourses: 'Search courses...',
          searchCellGroups: 'Search cell groups...',
          searchMeetings: 'Search meetings...',
          searchEvents: 'Search events...',
          from: 'From:',
          to: 'To:',
          clearFilter: 'Clear date filter',
          perPage: '{{count}} per page'
        },
        pagination: {
          showing: 'Showing {{from}} to {{to}} of {{total}} events',
          previous: 'Previous',
          next: 'Next'
        },
        loading: 'Loading events...',
        error: 'Error loading events',
        retry: 'Retry',
        management: {
          worship: 'Regular Worship Management',
          course: 'Courses Management',
          cellGroup: 'Cell Groups Management',
          meeting: 'Meetings Management',
          event: 'Events Management'
        },
        modal: {
          createTitle: 'Create New Event',
          editTitle: 'Edit Event',
          eventInfo: 'Event Information',
          eventName: 'Event Name *',
          eventNamePlaceholder: 'Enter event name',
          eventType: 'Event Type *',
          venue: 'Venue',
          venuePlaceholder: 'Enter venue',
          mainLecturer: 'Main Lecturer',
          mainLecturerPlaceholder: 'Enter main lecturer name(s)',
          mainLecturerNote: '(if not specified in sections)',
          defaultQuantity: 'Default Quantity',
          defaultQuantityPlaceholder: 'Enter default quantity',
          defaultQuantityNote: '(applies to all sections unless overridden)',
          remark: 'Remark',
          remarkPlaceholder: 'Enter remarks or additional notes',
          sectionsTitle: 'Sections/Classes',
          addSection: 'Add Section',
          sectionName: 'Section Name (Optional)',
          sectionNamePlaceholder: 'e.g., Morning Session, Class A',
          lecturer: 'Lecturer(s)',
          lecturerPlaceholder: 'e.g., John Doe, Jane Smith',
          quantity: 'Quantity',
          quantityPlaceholder: 'Enter quantity',
          startTime: 'Start Time *',
          startTimePlaceholder: 'Select start date & time',
          endTime: 'End Time *',
          endTimePlaceholder: 'Select end date & time',
          dragHandle: 'Drag to reorder',
          removeSection: 'Remove Section',
          noSections: 'At least one section is required',
          errors: {
            eventNameRequired: 'Event name is required',
            startTimeRequired: 'Start time is required',
            endTimeRequired: 'End time is required',
            endTimeAfterStart: 'End time must be after start time'
          },
          buttons: {
            save: 'Save Changes',
            saving: 'Saving...',
            create: 'Create Event',
            cancel: 'Cancel'
          }
        },
        confirmations: {
          deleteTitle: 'Delete Event?',
          deleteMessage: 'Are you sure you want to delete "{{name}}"? This will also delete all associated sections.',
          duplicateTitle: 'Duplicate Event?',
          duplicateMessage: 'Are you sure you want to duplicate "{{name}}"? A copy will be created with "(Copy)" appended to the name.',
          noChangesTitle: 'No Changes',
          noChangesMsg: 'No changes were made to update.'
        },
        notifications: {
          createSuccess: 'Event created successfully',
          updateSuccess: 'Event updated successfully',
          duplicateSuccess: 'Event duplicated successfully',
          deleteSuccess: 'Event deleted successfully',
          error: 'Failed to {{action}} event'
        },
        eventTypes: {
          worship: 'Regular Worship 常規崇拜',
          course: 'Course 課程',
          cellGroup: 'Cell Group 小組',
          meeting: 'Meeting 會議',
          event: 'Event 活動'
        }
      },
      dashboard: {
        secureNotice: 'Secure Admin Dashboard - Bearer token authentication enabled',
        welcomeTitle: 'Welcome back, {{name}}! 👋',
        welcomeSubtitle: "Here's what's happening with your CCBC platform today.",
        vsLastMonth: 'vs last month',
        recentActivitiesTitle: 'Recent Activities',
        quickActions: 'Quick Actions',
        systemStatus: 'System Status',
        stats: {
          totalAdmins: 'Total Admins',
          platformPosts: 'Platform Posts',
          joomlaArticles: 'Joomla Articles',
          activeSessions: 'Active Sessions'
        },
        navDebug: {
          title: 'Navigation Debug',
          currentUser: 'Current User:',
          testLinks: 'Test Direct Links (Click these to test navigation):',
          hint: "If these links don't work, check browser console for errors."
        },
        activities: {
          login: 'Admin logged in',
          create: 'New post created',
          update: 'Admin profile updated',
          system: 'System backup completed'
        },
        time: {
          justNow: 'Just now',
          twoHoursAgo: '2 hours ago',
          oneDayAgo: '1 day ago',
          twoDaysAgo: '2 days ago'
        },
        actions: {
          addAdmin: 'Add Admin',
          newPost: 'New Post',
          viewStats: 'View Stats',
          settings: 'Settings'
        },
        status: {
          backend: 'FastAPI Backend',
          database: 'MySQL Database',
          cms: 'Joomla CMS',
          operational: 'Operational',
          connected: 'Connected',
          accessible: 'Accessible'
        }
      }
      ,
      titheReceipts: {
        secureNotice: 'Secure Tithe Management - Bearer token authentication enabled',
        headerTitle: 'Tithe Receipt Management',
        refresh: 'Refresh',
        stats: {
          thisMonth: "This Month ({{month}})",
          allTime: 'All Time',
          receipts: 'Receipts',
          pending: 'Pending',
          approved: 'Approved',
          totalAmount: 'Total Amount'
        },
        controls: {
          searchPlaceholder: 'Search by name, phone, worship code, bank...',
          status: {
            all: 'All Status',
            pending: 'Pending',
            approved: 'Approved',
            rejected: 'Rejected'
          },
          year: { all: 'All Years' },
          month: {
            all: 'All Months',
            m01: 'January', m02: 'February', m03: 'March', m04: 'April', m05: 'May', m06: 'June',
            m07: 'July', m08: 'August', m09: 'September', m10: 'October', m11: 'November', m12: 'December'
          },
          perPage: '{{count}} per page'
        },
        table: {
          receiptInfo: 'Receipt Info',
          contact: 'Contact',
          paymentDetails: 'Payment Details',
          amount: 'Amount',
          status: 'Status',
          actions: 'Actions',
          worship: 'Worship',
          noEmail: 'No email'
        },
        actions: {
          view: 'View',
          approve: 'Approve',
          reject: 'Reject',
          download: 'Download'
        },
        statuses: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
        pagination: {
          showing: 'Showing {{from}} to {{to}} of {{total}} results',
          previous: 'Previous',
          next: 'Next',
          pageOf: 'Page {{page}} of {{total}}'
        },
        empty: {
          noResults: 'No tithe receipts found',
          tryAdjustSearch: 'Try adjusting your search criteria'
        },
        notifications: {
          fetchError: 'Failed to fetch tithe receipts',
          statsError: 'Failed to fetch statistics',
          statusUpdatedTitle: 'Status Updated',
          statusUpdatedMsg: 'Receipt {{status}} successfully',
          downloadStartedTitle: 'Download Started',
          downloadStartedMsg: 'Receipt file download started',
          downloadErrorTitle: 'Download Error',
          downloadErrorMsg: 'Failed to download receipt file'
        },
        modal: {
          title: 'Tithe Receipt #{{id}}',
          status: 'Status:',
          created: 'Created:',
          close: 'Close',
          approveTitle: 'Approve Receipt',
          approveConfirm: 'Are you sure you want to approve this tithe receipt?',
          approveRemarks: 'Approval Remarks (Optional):',
          approveAction: 'Approve',
          rejectTitle: 'Reject Receipt',
          rejectPrompt: 'Please provide a reason for rejecting this tithe receipt:',
          rejectReason: 'Rejection Reason:',
          rejectPlaceholder: 'Please explain why this receipt is being rejected...',
          rejectAction: 'Reject',
          cancel: 'Cancel',
          sections: {
            personal: 'Personal Information',
            address: 'Address Information',
            payment: 'Payment Information',
            donation: 'Donation Breakdown',
            additional: 'Additional Information'
          },
          fields: {
            chineseName: 'Chinese Name:',
            englishName: 'English Name:',
            contactPhone: 'Contact Phone:',
            email: 'Email:',
            worshipCode: 'Worship Code:',
            address: 'Address:',
            district: 'District:',
            area: 'Area/Country:',
            receivingBank: 'Receiving Bank:',
            transactionType: 'Transaction Type:',
            depositDate: 'Deposit Date:',
            referenceNumber: 'Reference Number:',
            titheAmount: 'Tithe Amount (當納十分一):',
            thanksgiving: 'Thanksgiving Offering (感恩奉獻):',
            churchOperating: 'Church Operating (教會經常費):',
            buildingFund: 'Building Fund (建堂基金):',
            gospelMinistry: 'Gospel Ministry (福音事工):',
            loveNeighbor: 'Love Neighbor Fund (愛鄰舍基金):',
            specialOffering: 'Special Offering (特別奉獻):',
            specialOfferingDesc: 'Special Offering Description:',
            totalAmount: 'Total Amount:',
            receiptRequired: 'Receipt Required:',
            yes: 'Yes',
            no: 'No',
            languagePreference: 'Language Preference:',
            uploadedReceipt: 'Uploaded Receipt:',
            remarks: 'Remarks:',
            processedBy: 'Processed By:',
            processedAt: 'Processed At:'
          }
        }
      }
    }
  },
  'zh-TW': {
    translation: {
      brand: { title: 'CCBC 後台', subtitle: '控制台' },
      navigation: {
        dashboard: '總覽',
        admins: '管理員管理',
        'tithe-receipts': '奉獻收據管理',
        members: '會友管理',
        organization: '組織架構',
        events: '聚會 / 活動',
        attendance: '出席記錄',
        check_in: 'QR 報到',
        continuous_checkin: '連續報到掃描',
        joomla: 'Joomla 文章',
        posts: '文章管理',
        'access-control': '權限設定'
      },
      navigationDesc: {
        dashboard: '平台統計與動態總覽',
        admins: '管理後台帳號與權限',
        posts: '建立、編輯並管理文章',
        events: '管理活動與分班時段',
        attendance: '查看與管理報到記錄',
        check_in: '掃描 QR Code 進行報到',
        continuous_checkin: '連續掃描多個 QR Code 報到',
        joomla: '查看並監察 Joomla 文章',
        'access-control': '設定使用者權限與存取',
        members: '管理會友資料與角色',
        organization: '檢視與維護組織架構',
        'tithe-receipts': '管理奉獻收據開立與記錄'
      },
      status: { online: '在線' },
      actions: { logoutConfirm: '確定要登出嗎？', logout: '登出' },
      language: { label: '語言', en: 'English', 'zh-TW': '繁體中文' },
      loading: { loading: '載入中...' },
      login: {
        title: 'CCBC 後台系統',
        subtitle: '請登入後台帳號',
        username: '帳號',
        password: '密碼',
        usernamePlaceholder: '輸入您的帳號',
        passwordPlaceholder: '輸入您的密碼',
        submit: '登入',
        submitting: '登入中...',
        loggingIn: '登入中...',
        footer: '© 2025 CCBC Project. 版權所有'
      },
      common: {
        na: '無',
        back: '返回',
        edit: '編輯',
        delete: '刪除',
        save: '儲存',
        cancel: '取消',
        successTitle: '成功',
        errorTitle: '錯誤'
      },
      member: {
        detail: {
          title: '會友詳細資料',
          backShort: '返回',
          backToList: '返回會友列表',
          loadingData: '正在載入會友資料...',
          failedToLoad: '載入會友資料失敗，請再試一次。',
          notFound: '找不到會友資料',
          confirmDelete: '確定要刪除 {{name}} 嗎？此動作無法復原。',
          successDeleteTitle: '成功',
          successDeleteMsg: '已成功刪除會友。',
          errorDeleteTitle: '錯誤',
          errorDeleteMsg: '刪除會友失敗，請再試一次。',
          personalInfo: '個人資訊',
          gender: '性別：',
          dob: '生日：',
          idNumber: '身分證號：',
          maritalStatus: '婚姻狀況：',
          occupation: '職業：',
          contactInfo: '聯絡資訊',
          mobile: '手機：',
          email: '電子郵件：',
          address: '住址：',
          membershipInfo: '會籍資訊',
          membershipType: '會籍類別：',
          joinDate: '加入日期：',
          baptismDate: '受洗日期：',
          baptismPlace: '受洗地點：',
          emergencyContact: '緊急聯絡人',
          contactName: '聯絡人姓名：',
          contactPhone: '聯絡人電話：',
          relationship: '關係：',
          additionalNotes: '其他備註',
          created: '建立時間：',
          lastUpdated: '最後更新：',
          worshipNo: '崇拜編碼'
        },
        list: {
          title: '會友管理',
          add: '新增會友',
          searchPlaceholder: '以姓名、崇拜編碼、手機或電郵搜尋...',
          statusAll: '全部狀態',
          statusActive: '啟用',
          statusInactive: '停用',
          statusSuspended: '停權',
          loading: '正在載入會友...',
          error: '載入會友失敗，請再試一次。',
          retry: '重試',
          table: {
            worship: '崇拜編碼',
            nameChi: '中文姓名',
            nameEng: '英文姓名',
            mobile: '手機',
            email: '電子郵件',
            status: '狀態',
            joinDate: '加入日期',
            actions: '操作'
          },
          empty: '沒有會友資料。',
          view: '查看',
          edit: '編輯',
          delete: '刪除',
          confirmDelete: '確定要刪除 {{name}} 嗎？',
          deleteSuccess: '已成功刪除會友！',
          deleteError: '刪除會友失敗，請再試一次。',
          pagination: {
            showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆會友',
            previous: '上一頁',
            next: '下一頁',
            pageOf: '第 {{page}} / {{total}} 頁'
          }
        },
        form: {
          createTitle: '新增會友',
          editTitle: '編輯會友',
          cancelConfirm: '確定要取消嗎？未儲存的變更將會遺失。',
          successCreate: '已成功建立會友！',
          successUpdate: '已成功更新會友！',
          save: '儲存',
          saving: '儲存中...',
          cancel: '取消',
          showAdvanced: '顯示更多詳細資料（地址、教育、小組、健康等）',
          hideAdvanced: '隱藏更多詳細資料（地址、教育、小組、健康等）',
          showAdvancedShort: '展開更多',
          hideAdvancedShort: '收起',
          updateAction: '更新會友',
          createAction: '建立會友',
          sections: {
            basic: '基本資料',
            contact: '聯絡方式',
            address: '地址',
            postalAddress: '郵寄地址',
            membership: '會籍',
            education: '教育',
            family: '家庭',
            occupation: '職業',
            baptism: '受洗',
            religion: '信仰背景',
            service: '事奉',
            cellGroup: '小組',
            health: '健康',
            emergency: '緊急聯絡人',
            communication: '訊息接收',
            remarks: '備註'
          },
          labels: {
            worshipId: '崇拜編碼',
            status: '狀態 *',
            chiName: '中文姓名 *',
            engName: '英文姓名',
            nickname: '暱稱',
            gender: '性別',
            dob: '生日',
            hkid: '身分證 / 護照',
            nativePlace: '籍貫',
            mobile: '手機',
            email: '電子郵件',
            telDay: '日間電話',
            telNight: '夜間電話',
            companyTel: '公司電話',
            fax: '傳真',
            addr: '地址',
            addrDistrict: '地區',
            region: '地區/區域',
            street: '街道',
            estate: '屋苑',
            building: '大廈',
            unitNumber: '單位/門牌',
            postalAddr: '郵寄地址',
            statusActive: '啟用',
            statusInactive: '停用',
            statusSuspended: '停權',
            dateOfJoin: '加入日期',
            dateOfJoinAdd: '再次加入日期',
            dateOfTransferAdd: '轉會日期',
            eduGrade: '教育程度',
            eduName: '教育',
            marriedStatus: '婚姻狀況',
            dateOfMarried: '結婚日期',
            childQty: '子女數目',
            job: '職業',
            income: '收入',
            workRegion: '工作地區',
            proQual: '專業資格',
            dateOfBaptism: '受洗日期',
            baptismChurch: '受洗教會',
            baptismNo: '受洗證號',
            baptistPriest: '施洗牧者',
            baptismAppointment: '受洗預約日期',
            religion: '宗教',
            everChurch: '曾經教會',
            believeDate: '決志日期',
            servePosts: '事奉崗位',
            serveExp: '事奉經驗',
            cellGroup1: '小組',
            cellGroup2: '小組 2',
            cellGroup3: '小組 3',
            cellGroup4: '小組 4',
            health: '健康',
            healthItems: '健康詳情',
            emergencyPerson: '緊急聯絡人',
            emergencyTel: '緊急聯絡電話',
            emergencyRelation: '關係',
            receiveInfo: '願意接收資訊',
            remark: '備註',
            remark2: '備註 2'
          },
          placeholders: {
            worshipId: '例：170074 或 T170074',
            statusFormat: '格式：正式會員 (170074) 或臨時會員 (T170074)',
            emergencyRelation: '例如：配偶、父母、兄弟姊妹',
            remark: '其他備註或說明...',
            eduGrade: '例如：中學、大學、碩士'
          },
          options: {
            genderSelect: '選擇性別',
            genderMale: '男',
            genderFemale: '女',
            genderOther: '其他',
            maritalSelect: '選擇婚姻狀況',
            maritalSingle: '單身',
            maritalMarried: '已婚',
            maritalDivorced: '離婚',
            maritalWidowed: '喪偶'
          },
          errors: {
            load: '載入會友資料失敗，請再試一次。',
            save: '儲存會友失敗，請再試一次。'
          }
        }
      },
      access: { deniedTitle: '無權限', deniedDescription: '您沒有權限存取此區域。' }
      ,
      admin: {
        secureNotice: '安全管理區域 - 所有 API 呼叫均以 Bearer 驗證保護',
        headerTitle: '管理員管理',
        headerSubtitle: '管理管理員與其權限',
        list: {
          addNewAdmin: '新增管理員',
          errorLoading: '載入管理員時發生錯誤',
          searchPlaceholder: '搜尋管理員...',
          perPage: '每頁 {{count}} 筆',
          table: {
            admin: '管理員',
            email: '電子郵件',
            status: '狀態',
            permissions: '權限',
            created: '建立時間',
            actions: '操作',
            active: '啟用',
            inactive: '停用',
            permissionsCount: '{{count}} 項權限',
            modulesCount: '{{count}} 個模組'
          },
          empty: '目前沒有管理員。',
          emptySearch: '找不到符合搜尋條件的管理員。',
          manage: '管理',
          delete: '刪除',
          confirmDelete: '確定要刪除此管理員嗎？',
          notifications: {
            deleteSuccess: '已成功刪除管理員',
            deleteError: '刪除管理員失敗'
          },
          pagination: {
            showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆管理員',
            previous: '上一頁',
            next: '下一頁'
          }
        },
        form: {
          title: '建立新管理員',
          username: '帳號',
          email: '電子郵件',
          firstName: '名',
          lastName: '姓',
          password: '密碼',
          passwordPlaceholder: '輸入安全密碼（至少 6 碼）',
          usernamePlaceholder: '輸入帳號',
          emailPlaceholder: '輸入電子郵件地址',
          firstNamePlaceholder: '名',
          lastNamePlaceholder: '姓',
          active: '啟用（可登入）',
          cancel: '取消',
          create: '建立管理員',
          creating: '建立中...',
          notifications: {
            createSuccess: '已成功建立管理員',
            createError: '建立管理員失敗'
          }
        },
        modal: {
          title: '管理管理員 - {{username}}',
          tabs: {
            edit: '編輯管理員',
            permissions: '權限設定'
          },
          info: {
            title: '權限設定說明',
            description: '設定此管理員可存取的模組與可執行的操作。'
          },
          fields: {
            username: '帳號',
            email: '電子郵件',
            firstName: '名',
            lastName: '姓',
            active: '啟用'
          },
          permissions: {
            create: '新增',
            read: '讀取',
            update: '更新',
            delete: '刪除',
            manage: '管理'
          },
          modules: {
            dashboard: '儀表板',
            admins: '管理員管理',
            members: '會友管理',
            events: '活動管理',
            attendance_records: '出席記錄',
            attendance_checkin: '出席報到',
            tithe_receipts: '奉獻收據管理',
            posts: '文章管理',
            joomla: 'Joomla 整合'
          },
          noChangesTitle: '沒有變更',
          noChangesMsg: '沒有任何變更可供更新。',
          save: '儲存變更',
          saving: '儲存中...',
          cancel: '取消',
          notifications: {
            updateSuccess: '已成功更新管理員',
            updateError: '更新管理員失敗',
            permsSuccess: '已成功更新權限',
            permsError: '更新權限失敗'
          }
        }
      },
      tithe: {
        secureNotice: '安全奉獻管理 - 已啟用 Bearer Token 驗證',
        title: '奉獻收據管理',
        refresh: '重新整理',
        searchPlaceholder: '以姓名、電話、崇拜編碼、銀行搜尋...',
        filters: {
          statusAll: '全部狀態',
          statusPending: '待審核',
          statusApproved: '已通過',
          statusRejected: '已拒絕',
          yearAll: '全部年份',
          monthAll: '全部月份',
          month01: '一月',
          month02: '二月',
          month03: '三月',
          month04: '四月',
          month05: '五月',
          month06: '六月',
          month07: '七月',
          month08: '八月',
          month09: '九月',
          month10: '十月',
          month11: '十一月',
          month12: '十二月',
          perPage: '每頁 {{count}} 筆'
        },
        stats: {
          monthlyTitle: '本月 ({{month}})',
          allTime: '全部期間',
          receipts: '收據數',
          pending: '待審核',
          approved: '已通過',
          totalAmount: '總金額'
        },
        table: {
          receiptInfo: '收據資訊',
          contact: '聯絡資料',
          payment: '付款資訊',
          amount: '金額',
          status: '狀態',
          actions: '操作',
          worship: '敬拜：',
          createdAt: '建立時間：',
          emailMissing: '無電郵',
          statusLabel: {
            pending: '待審核',
            approved: '已通過',
            rejected: '已拒絕'
          },
          view: '查看',
          approve: '通過',
          reject: '拒絕',
          download: '下載',
          breakdown: {
            tithe: '什一奉獻',
            building: '建堂基金',
            thanksgiving: '感恩奉獻',
            loveFund: '愛鄰舍基金'
          }
        },
        pagination: {
          showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆',
          previous: '上一頁',
          next: '下一頁',
          pageOf: '第 {{page}} / {{total}} 頁'
        },
        empty: {
          none: '目前沒有奉獻收據',
          adjust: '可嘗試調整搜尋條件'
        },
        notifications: {
          fetchError: '取得奉獻收據失敗',
          statsError: '取得統計資料失敗',
          statusUpdated: '收據已{{status}}',
          statusError: '更新狀態失敗',
          receiptError: '取得收據詳情失敗',
          downloadStarted: '開始下載收據檔案',
          downloadError: '下載收據檔案失敗'
        }
      },
      events: {
        secureNotice: '安全活動管理 - 已啟用 Bearer Token 驗證',
        title: '活動管理',
        tabs: {
          worship: '常規崇拜',
          course: '課程',
          cellGroup: '小組',
          meeting: '會議',
          event: '活動'
        },
        table: {
          id: 'ID',
          eventName: '活動名稱',
          venue: '地點',
          lecturer: '講員',
          sections: '分班',
          nextSection: '下次進行',
          created: '建立時間',
          actions: '操作',
          noEvents: '找不到活動。建立您的第一個活動！',
          noMatch: '找不到符合搜尋的活動。'
        },
        actions: {
          manage: '管理',
          duplicate: '複製',
          delete: '刪除',
          create: '建立{{type}}'
        },
        filters: {
          searchPlaceholder: '搜尋{{type}}...',
          searchWorships: '搜尋崇拜服務...',
          searchCourses: '搜尋課程...',
          searchCellGroups: '搜尋小組...',
          searchMeetings: '搜尋會議...',
          searchEvents: '搜尋活動...',
          from: '從:',
          to: '到:',
          clearFilter: '清除日期篩選',
          perPage: '每頁 {{count}} 筆'
        },
        pagination: {
          showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆活動',
          previous: '上一頁',
          next: '下一頁'
        },
        loading: '載入活動中...',
        error: '載入活動失敗',
        retry: '重試',
        management: {
          worship: '常規崇拜管理',
          course: '課程管理',
          cellGroup: '小組管理',
          meeting: '會議管理',
          event: '活動管理'
        },
        modal: {
          createTitle: '建立新活動',
          editTitle: '編輯活動',
          eventInfo: '活動資訊',
          eventName: '活動名稱 *',
          eventNamePlaceholder: '輸入活動名稱',
          eventType: '活動類型 *',
          venue: '地點',
          venuePlaceholder: '輸入地點',
          mainLecturer: '主講員',
          mainLecturerPlaceholder: '輸入主講員名字',
          mainLecturerNote: '（未在分班中指定時使用）',
          defaultQuantity: '預設數量',
          defaultQuantityPlaceholder: '輸入預設數量',
          defaultQuantityNote: '（應用於所有分班，除非另行指定）',
          remark: '備註',
          remarkPlaceholder: '輸入備註或額外說明',
          sectionsTitle: '分班/課堂',
          addSection: '新增分班',
          sectionName: '分班名稱（可選）',
          sectionNamePlaceholder: '例如：早堂、A班',
          lecturer: '講員',
          lecturerPlaceholder: '例如：John Doe, Jane Smith',
          quantity: '數量',
          quantityPlaceholder: '輸入數量',
          startTime: '開始時間 *',
          startTimePlaceholder: '選擇開始日期和時間',
          endTime: '結束時間 *',
          endTimePlaceholder: '選擇結束日期和時間',
          dragHandle: '拖動以排序',
          removeSection: '移除分班',
          noSections: '至少需要一個分班',
          errors: {
            eventNameRequired: '活動名稱為必填',
            startTimeRequired: '開始時間為必填',
            endTimeRequired: '結束時間為必填',
            endTimeAfterStart: '結束時間必須在開始時間之後'
          },
          buttons: {
            save: '儲存變更',
            saving: '儲存中...',
            create: '建立活動',
            cancel: '取消'
          }
        },
        confirmations: {
          deleteTitle: '刪除活動？',
          deleteMessage: '確定要刪除「{{name}}」嗎？這將刪除所有相關分班。',
          duplicateTitle: '複製活動？',
          duplicateMessage: '確定要複製「{{name}}」嗎？複製版本將附加「(複本)」到名稱。',
          noChangesTitle: '沒有變更',
          noChangesMsg: '沒有任何變更可供更新。'
        },
        notifications: {
          createSuccess: '已成功建立活動',
          updateSuccess: '已成功更新活動',
          duplicateSuccess: '已成功複製活動',
          deleteSuccess: '已成功刪除活動',
          error: '{{action}}活動失敗'
        },
        eventTypes: {
          worship: '常規崇拜 常規崇拜',
          course: '課程 課程',
          cellGroup: '小組 小組',
          meeting: '會議 會議',
          event: '活動 活動'
        }
      },
      organization: {
        title: '組織架構管理',
        subtitle: '牧區 → 分區 → 小組',
        legend: {
          district: '牧區',
          zone: '分區',
          group: '小組'
        },
        loading: '載入組織架構資料...',
        error: '無法載入組織架構資料。',
        reload: '重新載入',
        addFirst: '新增第一個區域',
        empty: '暫無組織架構',
        filters: {
          districtLabel: '牧區:',
          zoneLabel: '分區:',
          groupLabel: '小組:',
          districtPlaceholder: '搜尋牧區...',
          zonePlaceholder: '搜尋分區...',
          groupPlaceholder: '搜尋小組...',
          districtEmpty: '找不到牧區',
          zoneEmpty: '找不到分區',
          groupEmpty: '找不到小組',
          clearAll: '清除篩選'
        },
        actions: {
          addDistrict: '新增牧區',
          addZone: '新增分區',
          addGroup: '新增小組',
          manageMembers: '管理組員',
          edit: '編輯',
          delete: '刪除',
          groupCount: '{{count}} 小組',
          zoneCount: '{{count}} 分區'
        },
        badges: {
          district: '牧區',
          zone: '分區',
          group: '小組'
        },
        detail: {
          districtManager: '牧區長:',
          zoneManager: '區長:',
          groupManager: '組長:',
          noneAssigned: '未指派'
        },
        stats: {
          core: '核心組員',
          full: '正式組員',
          associate: '侯任組員',
          total: '總數'
        },
        confirmDelete: '確定要刪除此{{type}}嗎？',
        confirmRemoveMember: '確定移除這位組員嗎？',
        deleteError: '刪除失敗，請稍後再試。',
        saveError: '儲存失敗，請稍後再試。',
        removeError: '移除組員失敗。',
        types: {
          district: '牧區',
          zone: '分區',
          group: '小組',
          districtManager: '牧區長',
          zoneManager: '區長',
          groupManager: '組長'
        },
        modal: {
          createTitle: '新增',
          editTitle: '編輯',
          parentLabel: '上級{{parent}}',
          nameLabel: '{{type}}名稱 *',
          namePlaceholder: '例如：{{type}} 名稱',
          managerLabel: '{{manager}} *',
          loadingMembers: '載入會員中...',
          searchManager: '搜尋{{manager}}姓名或編號...',
          moreMembers: '還有 {{count}} 位會員...',
          noMembers: '找不到符合的會員',
          description: '描述',
          descriptionPlaceholder: '選填',
          cancel: '取消',
          save: '儲存'
        },
        membersModal: {
          title: '{{group}} 組員管理',
          summaryCore: '核心: {{count}}',
          summaryFull: '正式: {{count}}',
          summaryAssociate: '侯任: {{count}}',
          addLabel: '新增組員',
          searchPlaceholder: '搜尋會員姓名或編號...',
          loadingMembers: '載入會員中...',
          moreMembers: '還有 {{count}} 位會員...',
          noMembers: '找不到符合的會員',
          roleCore: '核心組員',
          roleFull: '正式組員',
          roleAssociate: '侯任組員',
          addButton: '加入',
*/

// Determine initial language from localStorage (persisted), fallback to Chinese
let initialLang = 'zh-TW';
try {
  if (typeof window !== 'undefined' && window.localStorage) {
    const stored = window.localStorage.getItem('ccbc-lang');
    if (stored && (stored === 'en' || stored === 'zh-TW')) {
      initialLang = stored;
    }
  }
} catch (e) {
  // Ignore storage access errors (private mode, etc.)
}

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: 'zh-TW',
  interpolation: { escapeValue: false }
});

export const supportedLanguages = [
  { code: 'en', label: 'English' },
  { code: 'zh-TW', label: '繁體中文' }
];

export default i18n;
